import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { GoodsCoreModel, IScreensLogging } from 'shared/src/api/types';

type LogClickLikeGoodsParams = {
  item: GoodsCoreModel;
  logging: IScreensLogging;
  currentLike: boolean;
};

export const useLogClickLikeGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ item, logging, currentLike }: LogClickLikeGoodsParams) => {
      const name = currentLike ? 'CLICK_UNLIKE_GOODS' : 'CLICK_LIKE_GOODS';

      logAnalyticsEvent({
        name,
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: logging.analytics,
        ably_only_log: logging.ably_only_log,
      });

      if (isNotNil(item.ad)) {
        bridge.logAdEvent({
          action: currentLike ? AdAction.UNLIKE : AdAction.LIKE,
          ad: item.ad,
        });
      }
    },
    [logAnalyticsEvent],
  );
};
